import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

export const AircraftNub = (props: { uavId: string; connected: boolean }) => {
  const theme = useTheme();
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      sx={{
        height: "40px",
        width: "79px",
        boxSizing: "border-box",
        borderRadius: 2,
        border: props.connected ? 1 : 0,
        borderColor: "text.primary",
        backgroundColor: props.connected
          ? "background.paper"
          : "other.disabledBackground",
      }}
      alignItems={"center"}
    >
      <Box
        display={"flex"}
        width={45}
        alignItems="center"
        justifyItems="center"
        sx={{}}
      >
        <Typography
          sx={{
            width: "100%",
            textAlign: "center",
          }}
          variant={"body2"}
          fontWeight={"600"}
          color={props.connected ? "text.primary" : "other.disabledText"}
        >
          {props.uavId}
        </Typography>
      </Box>
    </Box>
  );
};
